import { render, staticRenderFns } from "./doc_base.vue?vue&type=template&id=712140fe&scoped=true"
import script from "./doc_base.vue?vue&type=script&lang=js"
export * from "./doc_base.vue?vue&type=script&lang=js"
import style0 from "./doc_base.vue?vue&type=style&index=0&id=712140fe&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712140fe",
  null
  
)

export default component.exports